import { reportCopyFailure } from 'common/services';
import { addAppErrorMessage, addAppInfoMessage } from 'modules/alerts/state';
import { useAppDispatch } from 'store';

import { ErrorCode } from './ErrorCode';

import type { ApiExceptionMessage } from 'modules/api/utils';

type Props = ApiExceptionMessage;

export const ErrorCodeContainer = ({ ...apiExceptionMessage }: Props) => {
  const dispatch = useAppDispatch();
  const scope = apiExceptionMessage.stackTrace ? 'stack trace' : 'code';

  const handleCopySuccess = () => {
    dispatch(addAppInfoMessage(`Error ${scope} copied to clipboard`));
  };
  const handleCopyError = () => {
    reportCopyFailure('alerts.copy_error_code');
    dispatch(addAppErrorMessage(`Could not copy error ${scope} to clipboard. Please try again.`));
  };

  return (
    <ErrorCode scope={scope} onCopySuccess={handleCopySuccess} onCopyError={handleCopyError} {...apiExceptionMessage} />
  );
};
